import { useSelectedGroup } from "../../model/selected-group/context";
import { useGroupsOptions } from "../../model/selected-group/utils";
import { GroupSelectView } from "./group-select-view";

export function GroupSelect() {
  const groups = useGroupsOptions();
  const { selectedGroup, setSelectedGroup } = useSelectedGroup();

  return (
    <GroupSelectView
      options={groups}
      value={selectedGroup}
      onChange={setSelectedGroup}
    />
  );
}
